import React, { useCallback } from 'react'
import { useChangeMenuPageTitle, useMenuId, useNavigate } from '../../hooks'
import { useSetPreviewAsset } from '../../store'
import { useAssetsInfinite } from '../../api/query-hooks'
import { Skeleton } from '../../components/skeleton'
import { TopBodyLayout } from '../../components/top-body-layout'
import { Contact } from '../../components/connected-contact'
import { AssetCard } from '../../components/asset-card'
import { InfiniteScroll } from 'antd-mobile'
import styled from 'styled-components'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn'
import { Asset } from '../../api/backend'

dayjs.extend(relativeTime).locale('zh-cn')

const Container = styled.div`
  padding: 2rem 1.25rem;
  & > * + * {
    margin-top: 1.25rem;
  }
`
const File = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: stretch;
  & > * + * {
    margin-left: 0.5rem;
  }
  cursor: pointer;
`
const Cover = styled.img`
  flex: none;
  height: 5rem;
  width: 9rem;
  object-fit: contain;
`
const Info = styled.div`
  flex: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
`
const Title = styled.div`
  font-size: 0.875rem;
  font-weight: bold;
`
const Row = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  & > * + * {
    margin-left: 0.75rem;
  }
`
const Span = styled.span`
  font-size: 0.75rem;
`
const Tag = styled(Span)`
  color: ${props => props.theme.colors.theme};
`
const UpdateTime = styled(Span)`
  color: ${props => props.theme.colors.textTip};
`
export const Files: React.VFC = () => {
  useChangeMenuPageTitle()
  const navigate = useNavigate()
  const setAsset = useSetPreviewAsset()
  const menuId = useMenuId()
  const { data, hasNext, fetchNext } = useAssetsInfinite(menuId)
  const previewAsset = useCallback((asset: Asset) => {
    if (asset.resource) {
      setAsset(asset)
      navigate(`/preview/${asset.assertId}`)
    }
  }, [setAsset, navigate])
  return (
    <Skeleton
      value={data}
      render={data => (
        <TopBodyLayout
          top={<Contact />}
        >
          <Container>
            {data.map(asset => {
              const { assertId, tagsName, updateTime, assertName, uploader, fileCoverUrl, viewCount } = asset
              return (
                <AssetCard
                  key={assertId}
                  uploader={{
                    name: uploader.name,
                    avatar: uploader.avatar
                  }}
                  viewCount={viewCount}
                >
                  <File onClick={() => previewAsset(asset)}>
                    <Cover src={fileCoverUrl} alt={assertName} />
                    <Info>
                      <Title>{assertName}</Title>
                      <Row>
                        <Tag>{tagsName}</Tag>
                        <UpdateTime>{dayjs(updateTime).fromNow()}</UpdateTime>
                      </Row>
                    </Info>
                  </File>
                </AssetCard>
              )
            })}
            <InfiniteScroll loadMore={fetchNext} hasMore={hasNext} />
          </Container>
        </TopBodyLayout>
      )}
    />
  )
}
